/** @format */
import { DegreeProgramme, EntityWithRule, GroupingModule, StudyModule } from 'common-typescript/types';

export function isStudyModule(module: EntityWithRule): module is StudyModule {
    return module?.type === 'StudyModule';
}

export function isDegreeProgramme(module: EntityWithRule): module is DegreeProgramme {
    return module?.type === 'DegreeProgramme';
}

export function isGroupingModule(module: EntityWithRule): module is GroupingModule {
    return module?.type === 'GroupingModule';
}
